import { Link } from "react-router-dom";
import SiteHeader from "@/components/SiteHeader";
import SiteFooter from "@/components/SiteFooter";
import { useTranslate } from "@/i18n";

import { ArrowRight } from "lucide-react";

const About = () => {
  const t = useTranslate();
  return (
    <div className="flex min-h-screen flex-col">
      <SiteHeader />
      <main className="flex-1">
        <div className="container py-16 md:py-24">
          <div className="mx-auto max-w-2xl">
            <h1 className="mb-8 font-display text-4xl md:text-5xl text-foreground">
              {t("about.title")}
            </h1>

            <div className="space-y-6 text-lg leading-relaxed text-muted-foreground">
              <p>{t("about.body1")}</p>
              <p>{t("about.body2")}</p>
              <p>{t("about.body3")}</p>
            </div>

            <div className="mt-10">
              <Link
                to="/explore"
                className="group inline-flex items-center gap-2 font-medium text-primary underline underline-offset-4 transition-all duration-200 hover:gap-3"
              >
                {t("about.cta")}
                <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
              </Link>
            </div>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
};

export default About;
